import React, { useEffect, useState } from 'react';

import { handlePieData } from '../../constants';
import { getNewsChannel } from '@/pages/opinion/services/news';
import CardCommon from '@/pages/opinion/components/CardCommon';
import { useIntl } from 'umi';
import PieEchart from './Charts/PieEchart';
import BarEchart from './Charts/BarEchart';
import LineEchart from './Charts/LineEchart';
import { barHIcon, lineIcon, pieIcon } from '@/pages/opinion/constants/chart';

export default function ChannelChart({
  params,
  defaultType = 'pie',
}: {
  params: any;
  defaultType?: string;
}) {
  const [data, setData] = useState<any>({});
  const [loading, setLoading] = useState(true);
  const [type, setType] = useState(defaultType);

  const { formatMessage } = useIntl();

  useEffect(() => {
    setLoading(true);
    getNewsChannel({
      ...params,
      types: ['total', 'slice', 'sum'],
    })
      .then((data: any) => {
        setData(handlePieData(data, 'channel'));
      })
      .finally(() => {
        setLoading(false);
      });
  }, [params]);

  return (
    <CardCommon
      // hasTitleArrow
      title={formatMessage({ id: 'Channel' })}
      defaultOperation={type}
      operations={[barHIcon, lineIcon, pieIcon]}
      handleOperationsOnClick={({ symbol }) => setType(symbol)}
      loadingHeight={300}
      emptyHeight={300}
      loading={loading}
    >
      <div className="echart-data">
        {type === 'pie' && (
          <PieEchart
            chartData={data.mentions || []}
            total={data.pieMentionTotal || 0}
          ></PieEchart>
        )}

        {/* 新增的柱状图 */}
        {type === 'sentiment-h-bar' && (
          <BarEchart
            chartData={data.mentions || []}
            total={data.pieMentionTotal || 0}
          ></BarEchart>
        )}

        {type === 'line' && (
          <LineEchart
            chartData={data.timeline_of_mentions || []}
            dateType={params.date_type}
            startTime={params.start_time}
            endTime={params.end_time}
          ></LineEchart>
        )}
      </div>
    </CardCommon>
  );
}
